import {
  legalEntityKeys,
  legalEntityRepository,
} from '@webapp/platform/legal-entities/data-access/repositories/LegalEntityRepository'

/**
 * Shared react-query configs for reading LegalEntity data.
 *
 * `list` returns every entity (active + inactive) under a single query key, so
 * the list view and the duplicate-name check share one cached request.
 */
export const legalEntityQueryConfig = {
  list: () => ({
    queryKey: legalEntityKeys.list,
    queryFn: () => legalEntityRepository.list(),
  }),
}
